<h3 [hidden]="!dialogParams?.title" class="dialog-title">
  {{ dialogParams.title }}
</h3>
<div class="dialog" [ngClass]="{ noContentTitle: !dialogParams?.title }">
  <div class="dialog-content">
    <div [innerHTML]="dialogParams.content"></div>
  </div>
  <div class="dialog-actions">
    <button type="button" class="btn btn-fill" (click)="closeDialog()">{{ dialogParams.okText }}</button>
  </div>
</div>
